export const getLevelFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
  
    const entries = Array.from(params.entries());
    if (entries.length === 0) return { level: "", value: "" };
  
    const [level, value] = entries[entries.length - 1];
  
    return {
      level,
      value
    };
  };
  